import { render, staticRenderFns } from "./SearchForProducts.vue?vue&type=template&id=945473aa&scoped=true&"
import script from "./SearchForProducts.vue?vue&type=script&lang=js&"
export * from "./SearchForProducts.vue?vue&type=script&lang=js&"
import style0 from "./SearchForProducts.vue?vue&type=style&index=0&id=945473aa&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "945473aa",
  null
  
)

export default component.exports